var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-body"},[_c('div',{staticClass:"main-header_bg"}),_c('div',{staticClass:"main-header"}),_c('div',{staticClass:"main-container"},[_c('iframe',{staticClass:"main-iframe",staticStyle:{"width":"calc(100vw - 30px)","height":"calc(100vh - 54px)"},attrs:{"src":"http://101.34.200.62/emonitor"}})])])
}]

export { render, staticRenderFns }